/** Pages where no promo may ever interrupt, whatever an editor configures. */
const EXCLUDED_PREFIXES = ["/store/checkout", "/thankyou"];

function normalize(path: string): string {
  const bare = path.split(/[?#]/)[0].replace(/\/+$/, "");
  return bare === "" ? "/" : bare;
}

function isUnder(path: string, base: string): boolean {
  if (base === "/") return true;
  return path === base || path.startsWith(`${base}/`);
}

function matchesEntry(path: string, entry: string): boolean {
  if (entry.endsWith("*")) return isUnder(path, normalize(entry.slice(0, -1)));
  return path === normalize(entry);
}

/**
 * Whether a promo targeted at `pagePaths` may show on `pathname`. No paths means global.
 * An entry ending in `*` matches that path and everything beneath it (segment boundary).
 * Entries are trimmed, since Contentful's tag UI hides the whitespace editors paste in;
 * blank entries are ignored.
 */
export function matchesPage(pathname: string, pagePaths?: string[]): boolean {
  const path = normalize(pathname);
  if (EXCLUDED_PREFIXES.some(prefix => isUnder(path, prefix))) return false;
  const entries = (pagePaths ?? []).map(entry => entry.trim()).filter(Boolean);
  if (!entries.length) return true;
  return entries.some(entry => matchesEntry(path, entry));
}
